<template>
  <div id="users">
    <div
      id="content"
      class="content"
    >
      <div class="container">
        <h1 class="page-title">
          <i class="fal fa-users"></i> Utilisateurs
        </h1>
        <div
          class="info-button"
          @click.stop="$parent.toggleInfo"
        >
          <i class="fal fa-info-circle"></i> {{$parent.info_visible ? "Masquer les informations" : "Voir les informations"}} </div>
      </div>
      <div
        class="page-description"
        :class="{hidden: !$parent.info_visible}"
      >
        <b-message type="is-primary">
          <i class="fal fa-info-circle"></i>
          Pour <strong>affecter</strong> un Utilisateur à un Weezy, sélectionnez le dans le champ <strong>"Weezy"</strong>.
          <br>
        </b-message>
      </div>
    </div>
    <div class="content">
      <usersTable
        id="usersTable"
        :users="users"
        :weezys="weezys"
        :checkable="true"
      />
    </div>
  </div>
</template>


<script>
import usersTable from "@/components/usersTable";

import http from "@/modules/request";

export default {
  name: "users",
  components: {
    usersTable
  },
  data() {
    return {
      userId: "",
      name: "",
      surname: "",
      weezy_id: "",
      matricule: "",
      avatar: "",
      users: [],
      weezys: []
    };
  },
  mounted() {
    this.getUsers();
    this.getWeezys();
  },
  methods: {
    getUsers() {
      http
        .get("/privateusers")
        .then(response => {
          this.users = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getWeezys() {
      http
        .get("/weezys")
        .then(response => {
          this.weezys = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    showModify: function() {
      this.isModifyDisplayed = true;
      this.clearFields();
    },
    hideModify: function() {
      this.isModifyDisplayed = false;
    },
    submitModify: function() {
      http
        .patch("/users/" + this.userId, {
          user: { weezy_id: this.weezy_id }
        })
        .then(
          function(response) {
            this.getUsers();
            this.hideModify();
          }.bind(this)
        )
        .catch(function(error) {
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
        });
    },
    clearFields: function() {
      this.userId = "";
      this.name = "";
      this.weezy_id = "";
      this.surname = "";
    },
    modifyRows(rows) {
      var count = rows.length;
      var modifiedArray = [];
      // From latest to oldest
      for (var i = 0; i < count; i++) {
        var modified = rows[count - i - 1];
        if (!modifiedArray.includes(modified.id)) {
          modifiedArray.push(modified.id);
          this.userId = modified.id;
          this.weezy_id = modified.weezy_id;
          this.submitModify();
        }
      }
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
}

.read-only-text {
  background-color: #cccccc;
}
</style>